import { render } from "./Adjustment.vue?vue&type=template&id=188743cb&scoped=true"
import script from "./Adjustment.vue?vue&type=script&lang=js"
export * from "./Adjustment.vue?vue&type=script&lang=js"

import "./Adjustment.vue?vue&type=style&index=0&id=188743cb&scoped=true&lang=css"

import exportComponent from "D:\\vue\\rs459\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188743cb"]])

export default __exports__